import * as angular from 'angular';
import { Decimal } from 'decimal.js';
import { BigDecimal } from '../custom';

export interface MultiplyBigDecimalByIfFilter extends ng.IFilterFunction {}

function multiplyBigDecimalByIfFilter(): MultiplyBigDecimalByIfFilter {
    return function (
        input: BigDecimal,
        factor: number,
        condition: boolean
    ): BigDecimal {
        if (!input || !input.value || !condition) {
            return input;
        }

        let result: Decimal;

        if (angular.isString(input.value)) {
            result = new Decimal(input.value);
        } else {
            result = input.value;
        }

        return { value: result.times(factor), floatingPointNumber: true };
    };
}

angular
    .module('app')
    .filter('pkpMultiplyBigDecimalByIf', multiplyBigDecimalByIfFilter);
